type TestGridFields = {
  firstName: string;
  lastName: string;
  position: string;
  score: string;
  adj?: string;
  range?: string;
  sort?: string;
  eng?: string;
  green?: string;
  red?: string;
  blue?: string;
  yellow?: string;
  combinedDes: string;
  combinedWord: string;
};

/** Legacy KPSI single-row interpreter table (NAME … YELLOW). */
export default function KpsiInterpreterGrid({ test }: { test: TestGridFields }) {
  const fullName = `${test.firstName} ${test.lastName}`.trim();
  return (
    <div className="kpsi-table-responsive">
      <table className="kpsi-interpreter">
        <thead>
          <tr>
            <th>NAME</th>
            <th>POSITION</th>
            <th>SCORE</th>
            <th>ADJ</th>
            <th>RANGE</th>
            <th>DES</th>
            <th>SORT</th>
            <th>WORD</th>
            <th>ENG</th>
            <th className="green">GREEN</th>
            <th className="red">RED</th>
            <th className="blue">BLUE</th>
            <th className="yellow">YELLOW</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><pre>{fullName}</pre></td>
            <td><pre>{test.position}</pre></td>
            <td><pre>{test.score}</pre></td>
            <td><pre>{test.adj}</pre></td>
            <td><pre>{test.range}</pre></td>
            <td><pre>{test.combinedDes}</pre></td>
            <td><pre>{test.sort}</pre></td>
            <td><pre>{test.combinedWord}</pre></td>
            <td><pre>{test.eng}</pre></td>
            <td><pre>{test.green}</pre></td>
            <td><pre>{test.red}</pre></td>
            <td><pre>{test.blue}</pre></td>
            <td><pre>{test.yellow}</pre></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
